import { useEffect } from 'react';

import { useLatest } from '#/hooks/useLatest';

import type { SubmittedInterceptor } from './FormContext';
import { useFormContext } from './FormContext';

type Props = {
  onIntercept: SubmittedInterceptor;
};

/**
 * Allows performing actions such as handling errors after submitting the form.
 */
export function useFormSubmittedInterceptor({ onIntercept }: Props) {
  const { addSubmittedInterceptor } = useFormContext();

  const onInterceptRef = useLatest(onIntercept);

  useEffect(
    // Remove when unmounted
    () => {
      // make sure we're actually in form context
      if (addSubmittedInterceptor) {
        addSubmittedInterceptor(() => onInterceptRef.current());
      }
    },
    [addSubmittedInterceptor, onInterceptRef],
  );
}
